/**
 * Builds a `?a=1&b=2` query string for `GET` requests, omitting any
 * parameter whose value is `undefined` (docs/APP_PLAN.md §12 M4). Shared
 * by every paginated/list endpoint module in this package so query-string
 * construction lives in exactly one place.
 */
export function buildQueryString(params: Record<string, string | number | undefined>): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined) search.set(key, String(value));
  }
  const qs = search.toString();
  return qs.length > 0 ? `?${qs}` : '';
}
